<template>
  <div class="outer-box max-w-xl">
    <h4>Clean Up Twilio</h4>

    <b-alert show variant="info" class="text-left m-3">
     Clean Up Agency or Location Twilio
    </b-alert>

    <div class="inner-box">
      <div>Location ID</div>
      <input class="hl_input--wrap" type="text" placeholder="Location ID" v-model="locationId" />
      <br />
      <div>Company ID</div>
      <input class="hl_input--wrap" type="text" placeholder="Company ID" v-model="agencyId" />
      <br />
      <button
        :disabled="disabled || processing"
        class="btn btn-danger mt-4"
        @click="cleanUpTwilio"
      >
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Cleanup Twilio</span>
      </button>
      <pre v-if="response" class="bg-f2f7fa p-16 mt-16">{{ response }}</pre>
    </div>
  </div>
</template>

<script>
import { LCPhoneService } from "@/services";

export default {
  data() {
    return {
      locationId: "",
      processing: false,
      response: null,
      agencyId: "",
      cleanUpType: "location"
    };
  },
  computed: {
    disabled() {
      if (!this.locationId || !this.agencyId) return true;
      else return false;
    },
  },
  methods: {
    async cleanUpTwilio() {
      try {
        this.processing = true;
        await LCPhoneService.cleanUpTwilio(this.locationId,this.agencyId,this.cleanUpType).data
      } catch (err) {
        this.response = err.response.data;
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped>
.inner-box {
  text-align: left;
  width: 500px;
}
</style>
